module.exports = __webpack_public_path__ + "static/media/yelp.10ec45c8.png";